module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.campaign.subject))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [(this.$route.params.id) ? _c('submenu') : _vm._e(), _vm._v(" "), _c('codemirror', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.model.body),
      callback: function($$v) {
        _vm.$set(_vm.model, "body", $$v)
      },
      expression: "model.body"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Label_SaveButton"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_CancelButton",
      "withBorder": true
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'campaigns'
        })
      }
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57e2c49a!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/campaigns/form/CampaignEditCode.vue
// module id = 735
// module chunks = 1